import React from "react";
import * as styles from "./styles.module.scss";

/**
 * Recursively extracts URLs and their corresponding texts from a nested data structure.
 * This method looks for navigation links within objects and their children, including
 * sub-navigation links (`subnav_links`), child links (`children`), and call-to-action
 * links (`subnav_cta`). If no explicit link text is provided, defaults to "Link".
 *
 * @param {Object[]} data - The navigation data to be processed, typically an array of objects.
 * @returns {Object[]} A list of objects with `url` and `linkText` properties representing the extracted links.
 */
const extractLinks = (data) => {
  let links = [];

  function extract(obj) {
    if (obj.url) {
      const linkText = obj.link_text || obj.linkText || "Link";
      links.push({ url: obj.url, linkText });
    }

    if (obj.subnav_links) {
      obj.subnav_links.forEach(extract);
    }

    if (obj.children) {
      obj.children.forEach(extract);
    }

    if (obj.subnav_cta) {
      obj.subnav_cta.forEach(extract);
    }
  }

  data.forEach((item) => {
    return extract(item);
  });
  return links;
};

const SeoNavigation = (props) => {
  const normalizedMainLinks = extractLinks(props.mainLinks);

  return (
    <nav id="seo-header" className={styles.container}>
      <ul>
        {normalizedMainLinks.map((link, idx) => (
          <li key={idx}>
            <a href={link.url}>{link.linkText}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SeoNavigation;
